// Matomo may not be loaded (e.g. local dev); fall back to its queue array.
const trackPush = data => {
    (window._paq = window._paq || []).push(data);
};

const onHexagonClick = event => {
    var hexagon = event.currentTarget;
    var title = hexagon.getAttribute('data-title');

    // prevent double count on double clicks
    if (hexagon.getAttribute('data-clicked') === null) {
        trackPush([ 'trackEvent', 'Hexagon', 'Click auf Hexagon', title ]);
        hexagon.setAttribute('data-clicked', 1);
    } else {
        hexagon.setAttribute('data-clicked', (parseInt(hexagon.getAttribute('data-clicked')) + 1));
        trackPush([ 'trackEvent', 'Mehrfach-Click', 'Mehrfach-Click auf Hexagon', hexagon.getAttribute('data-clicked') ]);
    }
};

const onIshTeaserClick = event => {
    var ishTeaser = event.currentTarget;
    var page = window.location.href;
    // prevent double count on double clicks
    if (ishTeaser.getAttribute('data-clicked') === null) {
        trackPush([ 'trackEvent', 'ISH Teaser', 'Click auf ISH Teaser', page ]);
        ishTeaser.setAttribute('data-clicked', 1);
    } else {
        ishTeaser.setAttribute('data-clicked', (parseInt(ishTeaser.getAttribute('data-clicked')) + 1));
        trackPush([ 'trackEvent', 'Mehrfach-Click', 'Mehrfach-Click auf ISH-Teaser', ishTeaser.getAttribute('data-clicked') ]);
    }


};

const onSearchButtonClick = event => {
    var searchButton = event.currentTarget;
    var page = window.location.href;
    // prevent double count on double clicks
    if (searchButton.getAttribute('data-clicked') === null) {
        trackPush([ 'trackEvent', 'Suchbutton', 'Suche ausgeloest auf Seite', page ]);
        searchButton.setAttribute('data-clicked', 1);
    } else {
        searchButton.setAttribute('data-clicked', (parseInt(searchButton.getAttribute('data-clicked')) + 1));
        trackPush([ 'trackEvent', 'Mehrfach-Click', 'Mehrfach-Click auf Such-Button', searchButton.getAttribute('data-clicked') ]);
    }

};

const onServiceMenuClick = event => {
    var serviceLink = event.currentTarget;
    var title = serviceLink.textContent;
    var page = window.location.href;

    if (serviceLink.getAttribute('data-clicked') === null) {
        trackPush([ 'trackEvent', 'Service Menu', title , page ]);
        serviceLink.setAttribute('data-clicked', 1);
    } else {
        serviceLink.setAttribute('data-clicked', (parseInt(serviceLink.getAttribute('data-clicked')) + 1));
        trackPush([ 'trackEvent', 'Mehrfach-Click', 'Mehrfach-Click auf Service-Link', serviceLink.getAttribute('data-clicked') ]);
    }
};

const onJobAdvertisement = event => {
    var jobAdvertisement = event.currentTarget;
    var linkHref = jobAdvertisement.href;

    if (jobAdvertisement.getAttribute('data-clicked') === null) {
        trackPush([ 'trackEvent', 'Stellenanzeigen',' weiter', linkHref ]);
        jobAdvertisement.setAttribute('data-clicked', 1);
    } else {
        jobAdvertisement.setAttribute('data-clicked', (parseInt(jobAdvertisement.getAttribute('data-clicked')) + 1));
        trackPush([ 'trackEvent', 'Mehrfach-Click', 'Mehrfach-Click auf weiter', jobAdvertisement.getAttribute('data-clicked') ]);
    }
};

const onJobSearchClick = event => {
    var jobSearch = event.currentTarget;
    var page = window.location.href;
    var form = jobSearch.closest('form');
    var categoryText = form.querySelector('select[name="tx_pbeakkjobs_jobs[category]"] option:checked').textContent.trim();
    var locationText = form.querySelector('select[name="tx_pbeakkjobs_jobs[location]"] option:checked').textContent.trim();
    var name = `${categoryText} / ${locationText}`;

    if (jobSearch.getAttribute('data-clicked') === null) {
        trackPush([ 'trackEvent', 'Jobs finden', 'Finden abgesendet', name, page ]);
        jobSearch.setAttribute('data-clicked', 1);
    } else {
        jobSearch.setAttribute('data-clicked', (parseInt(jobSearch.getAttribute('data-clicked')) + 1));
        trackPush([ 'trackEvent', 'Mehrfach-Click', 'Mehrfach-Click auf Finden', jobSearch.getAttribute('data-clicked') ]);
    }
};

// Salary Calculator
// Only count submissions that pass form validation.
const onSalaryCalculatorSubmit = event => {
    var submitButton = event.target.closest('.salary-calculator__form--submit');
    if (!submitButton) {
        return;
    }

    var form = submitButton.closest('form');
    // only register the click when the form is actually submitted (valid)
    if (!form || !form.checkValidity()) {
        return;
    }

    var salaryGroup = form.querySelector('#salary-group');
    var title = salaryGroup ? salaryGroup.value : '';

    if (submitButton.getAttribute('data-clicked') === null) {
        trackPush([ 'trackEvent', 'Gehaltsrechner', 'Berechnen abgesendet', title ]);
        submitButton.setAttribute('data-clicked', 1);
    } else {
        submitButton.setAttribute('data-clicked', (parseInt(submitButton.getAttribute('data-clicked')) + 1));
        trackPush([ 'trackEvent', 'Mehrfach-Click', 'Mehrfach-Click auf Gehaltsrechner', submitButton.getAttribute('data-clicked') ]);
    }
};

// Teaser With Icon
const onTeaserWithIconClick = event => {
    var teaserWithIcon = event.currentTarget;
    var page = window.location.href;
    // prevent double count on double clicks
    if (teaserWithIcon.getAttribute('data-clicked') === null) {
        trackPush([ 'trackEvent', 'Teaser mit Icon', 'Click auf Teaser mit Icon', page ]);
        teaserWithIcon.setAttribute('data-clicked', 1);
    } else {
        teaserWithIcon.setAttribute('data-clicked', (parseInt(teaserWithIcon.getAttribute('data-clicked')) + 1));
        trackPush([ 'trackEvent', 'Mehrfach-Click', 'Mehrfach-Click auf Teaser mit Icon', teaserWithIcon.getAttribute('data-clicked') ]);
    }
};

const init = () => {
    //track clicks on hexagons
    var hexagons = document.querySelectorAll('li.hexagone-teaser-list__item a');
    for (var i = 0; i < hexagons.length; i++) {
        // console.log('add hexagon click event' + i);
        hexagons[i].addEventListener('click', onHexagonClick);
    }

    // track ISH-Bannerpage
    var ishTeasers = document.querySelectorAll('.ish-wrapper');
    for (var j = 0; j < ishTeasers.length; j++) {
        ishTeasers[j].addEventListener('click', onIshTeaserClick);
    }

    // track search button on homepage and subpages
    var searchButtons = document.querySelectorAll('button.btn-search, .search-modal [type=submit]');
    for (var k = 0; k < searchButtons.length; k++) {
        searchButtons[k].addEventListener('click', onSearchButtonClick);
    }

    // track links from service navigation
    var serviceNavLinks = document.querySelectorAll('.services-panel__item a');
    for (var l = 0; l < serviceNavLinks.length; l++) {
        serviceNavLinks[l].addEventListener('click', onServiceMenuClick);
    }

    // track links for Job Advertisements
    var jobAdvertisements = document.querySelectorAll('[class*="frame--"].frame-type-text a');
    for (var m = 0; m < jobAdvertisements.length; m++) {
        jobAdvertisements[m].addEventListener('click', onJobAdvertisement);
    }


    var jobSearchForms = document.querySelectorAll('.jobs-locator__form form #jobs-locator-submit');
    for (var n = 0; n < jobSearchForms.length; n++) {
        jobSearchForms[n].addEventListener('click', onJobSearchClick);
    }

    // track salary calculator submissions
    var salaryCalculatorForm = document.getElementById('salary-calculator-form');
    if (salaryCalculatorForm) {
        salaryCalculatorForm.addEventListener('click', onSalaryCalculatorSubmit, true);
    }

    // track teaser with icon
    var teasersWithIcon = document.querySelectorAll('.button-teaserblockicon');
    for (var o = 0; o < teasersWithIcon.length; o++) {
        teasersWithIcon[o].addEventListener('click', onTeaserWithIconClick);
    }
};

export {
    init,
};


